module.exports = __webpack_public_path__ + "static/3hr-c0b6a2538ce2a95754fe3bc6a8b464c9.svg";